import { Icon } from '@aibees/shared/components';
import { classnames, fNumber } from '@aibees/shared/utils';
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { UsageAnalyticsIncomesProps as Props } from './types';

export const ApiUsageAnalyticsIncomes = memo(
  ({ className, title, total, loading, icon }: Props) => {
    return (
      <Card
        className={classnames('ApiUsageAnalyticsIncomes', className)}
        sx={SX.root}
        variant="outlined"
        headerDivider
      >
        <CardHeader
          title={
            <Stack direction="row" alignItems="center" gap={1}>
              <Icon name={icon || 'coin'} size={22} color="primary.500" />
              <Typography variant="body3" color="grey.700" fontWeight={700}>
                {title}
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <Typography variant="body2" color="grey.700" fontWeight={700}>
            {!loading ? fNumber(total ?? 0) : <Icon name="loading" size={24} />}
          </Typography>
        </CardContent>
      </Card>
    );
  }
);

ApiUsageAnalyticsIncomes.displayName = 'ApiUsageAnalyticsIncomes';
